(function () {
    const pageKey = document.querySelector('[data-page]')?.getAttribute('data-page');
    if (pageKey === 'conferences') {
        document.querySelectorAll('.conferences-list').forEach((conferencesList) => {
            const searchInput = conferencesList.querySelector('.conferences-search-input');
            const conferences = conferencesList.querySelectorAll('.conference-block');
            const filtersButton = conferencesList.querySelector('.other-filters-button');
            const noResultMessage = conferencesList.querySelector('.no-search-result');
            let searchValue = '';
            const formats = {
                'round_table': false,
                'masterclass': false,
                'keynote': false,
                'workshop': false,
                'cocktail': false,
            };
            const rooms = {
                'alveole_11': false,
                'alveole_12': false,
                'alveole_13': false,
                'salon_port': false,
                'terrasse_alveole_12': false,
                'ponton_alveole_12': false
            };

            const updateConferences = () => {
                const totalConferences = conferences.length;
                let hiddenConferences = 0;

                conferences.forEach((conference) => {
                    let isVisible = true;

                    if (searchValue) {
                        const valueInTitle = conference.querySelector('.conference-title')
                            .innerHTML.toLowerCase().includes(searchValue);
                        const valueInDescription = conference.querySelector('.conference-details')
                            .innerHTML.toLowerCase().includes(searchValue);

                        isVisible = valueInTitle || valueInDescription;
                    }

                    if (isVisible && Object.values(rooms).includes(true)) {
                        isVisible = rooms[conference.getAttribute('data-room')];
                    }

                    if (isVisible && Object.values(formats).includes(true)) {
                        isVisible = formats[conference.getAttribute('data-format')];
                    }

                    if (isVisible) {
                        conference.classList.remove('d-none');
                    } else {
                        conference.classList.add('d-none');
                        hiddenConferences++;
                    }
                });

                if (hiddenConferences === totalConferences) {
                    noResultMessage.classList.remove('d-none');
                } else {
                    noResultMessage.classList.add('d-none')
                }
            };

            const updateSearchValue = () => {
                searchValue = searchInput.value.toLowerCase();
                updateConferences();
            };

            const updateFormat = (format) => {
                formats[format] = ! formats[format];
                updateConferences();
            };

            const updateRooms = (roomButton) => {
                const room = roomButton.getAttribute('data-room');
                rooms[room] = ! rooms[room];
                roomButton.classList.toggle('selected');
                updateConferences();
            };

            conferencesList.querySelector('.conferences-formats')?.querySelectorAll('input').forEach((formatInput) => {
                formatInput.checked = false;
                formatInput.addEventListener('change', (event) => updateFormat(event.target.value));
            });

            conferencesList.querySelector('.conferences-rooms')?.querySelectorAll('button').forEach((roomButton) => {
                roomButton.addEventListener('click', (event) => updateRooms(event.target));
            });

            filtersButton?.addEventListener('click',() => {
                conferencesList.querySelector('.other-filters')?.classList.toggle('d-none');
                filtersButton.querySelectorAll('span').forEach((msg) => {
                    msg.classList.toggle('d-none');
                });
            });

            if (searchInput) {
                searchInput.value = '';

                let typingTimer;
                searchInput.addEventListener('keyup', () => {
                    clearTimeout(typingTimer);
                    typingTimer = setTimeout(updateSearchValue, 500);
                });
            }
        });
    }
})();
